<div [@.disabled]="nativeDesktop" [ngClass]="{ app_wrapper: true, nativeDesktop: nativeDesktop }">
  <bfx-popup-notification-container *ngIf="oms"></bfx-popup-notification-container>
  <bfx-dialogs></bfx-dialogs>
  <router-outlet
    (activate)="componentAdded($event)"
    (deactivate)="componentRemoved($event)"
  ></router-outlet>
</div>
